import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "When a free day is busy",
  "description": "",
  "published": "2006-04-27T00:00:00.000Z",
  "redirect_from": ["/blog/when-a-free-day-is-busy/swizec/426"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today was the first day of 6 days where there is no official obligation of any kind. Some national holidays nobody cares of mixed together with a single day that is absolutely free but would not have to be creates the so called "First of May holiday". It's a nice tradition and it comes in handy for catching up with ral life instead of having to deal with school all the time.`}</p>
    <p>{`Today though, the day was not completely free of stuff as I valiantly went to help an ex school mate with his graduation paper so that he may graduate from highschool with a grade that is decent or even better than that. We laboured for nigh on 10 hours and came up with seventeen pages of writen documentation for a snake game. It was an interesting experience, yet very frightening as the same awaits me next year, very frightening indeed.`}</p>
    <p>{`Also today, more like this evening, I watched the movie `}<a parentName="p" {...{
        "href": "http://www.imdb.com/title/tt0349683/"
      }}>{`King Arthur`}</a>{` which was very good and had quite an interesting twist to the ancient tale. It was great, everyone who is into lore and mythology should see it, and even those who are not into such things. Sadly, weak and weary and very dreary I nodded but a little but it was alas enough to miss parts of the movie and it shall have to be seen again... soon.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.rapper.it/King%20Arthur-Guinevere.jpg",
        "alt": null
      }}></img></p>
    <p>{`In other news, I have gotten the `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=show_comics/comic=0"
      }}>{`placeholder`}</a>{` for the comic up a few days ago but the banners eluded me by being very hard and difficult to design. This should be getting done before the end of this series of free days and work on the first comic will also start sometime about now. It should be up ere the end of the first week of May.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      